const STYLES = {
  veg: { box: "border-emerald-600", dot: "bg-emerald-600", label: "Veg" },
  nonveg: { box: "border-red-600", dot: "bg-red-600", label: "Non-veg" },
  egg: { box: "border-amber-500", dot: "bg-amber-500", label: "Egg" },
};

export const VegMark = ({ type = "veg" }) => {
  const s = STYLES[type] || STYLES.veg;
  return (
    <span
      className={`inline-flex h-3 w-3 shrink-0 items-center justify-center rounded-[2px] border ${s.box}`}
      title={s.label}
      aria-label={s.label}
      data-testid={`veg-mark-${type}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
    </span>
  );
};

export const DishList = ({ dishes, items, testid }) => {
  if (!dishes?.length)
    return <p className="text-[13px] text-muted-foreground">{items ? items : "—"}</p>;
  return (
    <ul className="flex flex-wrap gap-x-3 gap-y-1.5" data-testid={testid}>
      {dishes.map((d, i) => (
        <li key={`${d.name}-${i}`} className="flex items-center gap-1.5 text-[13px] text-muted-foreground">
          <VegMark type={d.type} /> {d.name}
        </li>
      ))}
    </ul>
  );
};

export const VegLegend = () => (
  <div className="flex flex-wrap items-center gap-4 text-[11px] font-semibold text-muted-foreground" data-testid="veg-legend">
    {Object.entries(STYLES).map(([k, s]) => (
      <span key={k} className="flex items-center gap-1.5">
        <VegMark type={k} /> {s.label}
      </span>
    ))}
  </div>
);
